export const isNorwegianMobileNumberRegex = /^(4|9)((\d{7})|(\d\s?\d\s?\d\s?\d\s?\d\s?\d\s?\d\s?)\s*)$/;

export const formatPhoneNumber = (num = '') => {
  if (!isValidPhoneNumber(num)) {
    return num;
  }
  return num
    .split('')
    .reduce((formattedNumber, digit, idx) => `${formattedNumber}${[3, 5].includes(idx) ? ' ' : ''}${digit}`, '');
};

export const normalizePhoneNumber = (phoneNumber: string) => {
  const normalizedNumber = phoneNumber.replace(/\+|\s/g, '').replace(/^00/, '');
  return normalizedNumber.length === 8 ? `47${normalizedNumber}` : normalizedNumber;
};

// Remove (+47, 0047, 47) and spaces, return only the 8-digit local part.
export const normalizePhoneNumber8Digits = (raw: string): string => {
  return String(raw ?? '')
    .replace(/\D/g, '')
    .replace(/^47/, '')
    .replace(/^0047/, '')
    .slice(-8);
};

export const isValidPhoneNumber = (phoneNumber: string) => {
  // Strip away +47 or 0047 and check if remaining is exactly 8 digits
  const stripped = phoneNumber.replace(/^(\+47|0047)/, '');
  return /^\d{8}$/.test(stripped);
};
